
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SobreEmpresa',
    props: {
        Titulo: {
            type: String,
            default: "Solidez e confiança desde 2010."
        },
        TextoPrimerioPagrafo: {
            type: String,
            default: ""
        },
        TituloPrimeiroParagrafo: {
            type: String,
            default: ""
        },
        TextoSegundoPagrafo: {
            type: String,
            default: ""
        },
        TituloSegundoParagrafo: {
            type: String,
            default: ""
        },
    }
});
